import { createSlice } from "@reduxjs/toolkit"
import moment from "moment"
import { AVG_SORT_ORDER, DEPARTMENT_FILTER, DETAILS_INDIVIDUAL_PERFORMANCE_FILTER, SCORE_FILTER } from "../../utilities/constants"

const DetailsIndividualPerformanceSlice = createSlice({
  name: "DETAILS_INDIVIDUAL_PERFORMANCE",
  initialState: {
    filters: {
      [DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.AVG_SORT_ORDER]: AVG_SORT_ORDER.DEFAULT,
      [DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.DEPARTMENT]: DEPARTMENT_FILTER.ALL,
      [DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MIN_SCORE]: SCORE_FILTER.ZERO,
      [DETAILS_INDIVIDUAL_PERFORMANCE_FILTER.MAX_SCORE]: SCORE_FILTER.ONE_HUNDRED,
    },
    searchText: "",
    currentHistoricalDate: null,
  },
  reducers: {
    // Search Individual Performances
    setSearchText: (state, action) => {
      const _searchText = action?.payload
      state.searchText = typeof _searchText === "string" ? _searchText.trim() : ""
    },

    // Filter Individual Performance
    // action.payload to be like { filterParam: string, filterValue: string | string[] }
    setFilters: (state, action) => {
      const filterKey = action?.payload.filterParam
      const filterValue = action?.payload.filterValue
      const filters = { ...state.filters }
      if (Object.keys(state.filters).includes(filterKey)) {
        filters[filterKey] = filterValue
      }
      state.filters = { ...filters }
    },

    // Updated Historical Date can be set here
    // action.payload to be like { currentDate: null | ISO Date string }
    setCurrentHistoricalDate: (state, action) => {
      const { date } = action.payload
      if (date && moment(date).isValid()) {
        state.currentHistoricalDate = date
      } else {
        state.currentHistoricalDate = null
      }
    },
  },
})

export const DetailsIndividualPerformanceActions = DetailsIndividualPerformanceSlice.actions
export default DetailsIndividualPerformanceSlice
